import { render, staticRenderFns } from "./ModDownloadJobs.vue?vue&type=template&id=2244e38f&lang=pug&"
import script from "./ModDownloadJobs.vue?vue&type=script&lang=ts&"
export * from "./ModDownloadJobs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports